<script lang="ts" setup>
import { _isMobile, isWxMiniProgram } from '@/utils/is'
import { onBeforeUnmount, onMounted } from 'vue'
import { useStorage } from '@/hooks/web/useStorage'
import { getLoginInfo } from '@/utils/CryptoJS'
import { setArms } from '@/utils/tools.js'
import GlobalLoading from '@/components/global-loading/index.vue'

const { getStorage } = useStorage()

const onVisibilityChange = () => {
  // volvo 项目去掉息屏亮屏后刷新
  console.info('onVisibilityChange', document.visibilityState)
  /* if(document.visibilityState === 'visible' && _isMobile() && appStore.getCanReload){
      window.location.reload();
  } */
  if (isWxMiniProgram() && document.visibilityState === 'hidden') {
    leaveRoom()
  }
}

const leaveRoom = () => {
  // 若本地有栏目id 缓存则不上报
  console.log('test_beforeunload', getLoginInfo('token'))
  if (!getLoginInfo('name')) return
  if (/personal|column/.test(window.location.href)) {
    return
  }
  let url: any = import.meta.env.VITE_BASE_URL + '/live/leaveRoom'
  navigator.sendBeacon(url + `?roomId=${getStorage('roomId')}&token=${getLoginInfo('token')}`)
  // navigator.sendBeacon(url+`?liveWatchRecordId=${getStorage("liveWatchRecordDatId")}&inviteAccountId=${getStorage("accountId")}&liveRecordId=${getStorage("liveRecordId")}&roomId=${getStorage("roomId")}&token=${getLoginInfo("token")}`);
}

onMounted(() => {
  setArms(getLoginInfo('userId'), getLoginInfo('name')) // arms
  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('beforeunload', leaveRoom)
  // window.addEventListener("unload", test);
  if (_isMobile()) {
    // 禁止移动端页面滚动
    document.body.style.overflow = 'hidden'
  }
})

onBeforeUnmount(() => {
  console.log('--------离开页面')
  document.removeEventListener('visibilitychange', onVisibilityChange)
})
</script>

<template>
  <RouterView />
  <GlobalLoading />
</template>

<style lang="less"></style>
